import { ReactNode } from "react";

export interface IRow {
  children: ReactNode;
  className?: string;
}

function Row({ children, className }: IRow) {
  return <div className={`row ${className}`}>{children}</div>;
}
export default Row;
